import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ContactService {
  public url = ""; //environment.apiBackend + 'contact';

  constructor(protected http: HttpClient) {}

  public sendEmail(data) {
    const headers = new HttpHeaders({
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "location",
    });
    return this.http
      .post<any>(
        "https://cubo-demos.com.ar/prod/app/form/process/59b15b0208bf6b692ee1c503691f71fd",
        data,
        { headers }
      )
      .pipe(map((response: any) => response));

    // data.mail = "";
    // const headers = new HttpHeaders({
    //   "Content-Type": "application/json",
    // });
    // const body = JSON.stringify(data);
    // return this.http
    //   .post(this.url, body, { headers })
    //   .pipe(map((response: any) => response));
  }
}
